__turbopack_context__.v({
  "aboutheading1": "prestorming-module__eAGBiq__aboutheading1",
  "aboutparagraph1": "prestorming-module__eAGBiq__aboutparagraph1",
  "aboutparagraph2": "prestorming-module__eAGBiq__aboutparagraph2",
  "acheivername": "prestorming-module__eAGBiq__acheivername",
  "acheiverrank": "prestorming-module__eAGBiq__acheiverrank",
  "acheiverrank1": "prestorming-module__eAGBiq__acheiverrank1",
  "acheiverrankspecial": "prestorming-module__eAGBiq__acheiverrankspecial",
  "bangmainTitle": "prestorming-module__eAGBiq__bangmainTitle",
  "bestbg1": "prestorming-module__eAGBiq__bestbg1",
  "blinking": "prestorming-module__eAGBiq__blinking",
  "bodred": "prestorming-module__eAGBiq__bodred",
  "branchBtn": "prestorming-module__eAGBiq__branchBtn",
  "captcha": "prestorming-module__eAGBiq__captcha",
  "cardBox": "prestorming-module__eAGBiq__cardBox",
  "carouselImg": "prestorming-module__eAGBiq__carouselImg",
  "carouselWrapper": "prestorming-module__eAGBiq__carouselWrapper",
  "checkboxcontent": "prestorming-module__eAGBiq__checkboxcontent",
  "checkiconcss": "prestorming-module__eAGBiq__checkiconcss",
  "contactheader": "prestorming-module__eAGBiq__contactheader",
  "content": "prestorming-module__eAGBiq__content",
  "contentbg": "prestorming-module__eAGBiq__contentbg",
  "contl": "prestorming-module__eAGBiq__contl",
  "dark": "prestorming-module__eAGBiq__dark",
  "dot": "prestorming-module__eAGBiq__dot",
  "dot1": "prestorming-module__eAGBiq__dot1",
  "downloadicon": "prestorming-module__eAGBiq__downloadicon",
  "facultyborder3": "prestorming-module__eAGBiq__facultyborder3",
  "formstar": "prestorming-module__eAGBiq__formstar",
  "handicon": "prestorming-module__eAGBiq__handicon",
  "heading3d": "prestorming-module__eAGBiq__heading3d",
  "imagee": "prestorming-module__eAGBiq__imagee",
  "invalidCheck2": "prestorming-module__eAGBiq__invalidCheck2",
  "mainTitle": "prestorming-module__eAGBiq__mainTitle",
  "normalbutton": "prestorming-module__eAGBiq__normalbutton",
  "normalbutton1": "prestorming-module__eAGBiq__normalbutton1",
  "normalbutton2": "prestorming-module__eAGBiq__normalbutton2",
  "numberbold": "prestorming-module__eAGBiq__numberbold",
  "pagemaintitle": "prestorming-module__eAGBiq__pagemaintitle",
  "paybill": "prestorming-module__eAGBiq__paybill",
  "phone": "prestorming-module__eAGBiq__phone",
  "phoneiconcss": "prestorming-module__eAGBiq__phoneiconcss",
  "prebg": "prestorming-module__eAGBiq__prebg",
  "presbg": "prestorming-module__eAGBiq__presbg",
  "program": "prestorming-module__eAGBiq__program",
  "redunderline": "prestorming-module__eAGBiq__redunderline",
  "redunderlinealink": "prestorming-module__eAGBiq__redunderlinealink",
  "sectionredtitle": "prestorming-module__eAGBiq__sectionredtitle",
  "sectionsubtitle": "prestorming-module__eAGBiq__sectionsubtitle",
  "sectiontitle": "prestorming-module__eAGBiq__sectiontitle",
  "sectiontitle1": "prestorming-module__eAGBiq__sectiontitle1",
  "startegy": "prestorming-module__eAGBiq__startegy",
  "startegy1": "prestorming-module__eAGBiq__startegy1",
  "tablebg": "prestorming-module__eAGBiq__tablebg",
  "tableheading": "prestorming-module__eAGBiq__tableheading",
  "tablinks": "prestorming-module__eAGBiq__tablinks",
  "tabscrollclass": "prestorming-module__eAGBiq__tabscrollclass",
  "tabsection": "prestorming-module__eAGBiq__tabsection",
  "ulclass": "prestorming-module__eAGBiq__ulclass",
  "ulliclass": "prestorming-module__eAGBiq__ulliclass",
  "ullispan": "prestorming-module__eAGBiq__ullispan",
  "whatsnewkeyanimation": "prestorming-module__eAGBiq__whatsnewkeyanimation",
});
